import React from "react";
import { Table } from "../../../../layout";
import { formatDecimal } from "../../../../hooks/Method";

const ReturnItems = ({ value }) => {
  return (
    <div>
      <Table
        ActionComp={() => <></>}
        HeaderComp={() => <></>}
        tblHead={[
          { id: "product", label: "Product" },
          { id: "qty", label: "Quantity" },
          { id: "costPrice", label: "Cost Price	" },
          { id: "totalCost", label: "Total Cost	" },
        ]}
        tblData={value.stockReturnItems.map((item) => {
          return {
            ...item,

            searchTerm: item.prod ? `${item.label} ${item.subtitle}` : "",
            product: (
              <div className="flex flex-col cursor-pointer">
                <span className="text-[14px] font-medium tracking-wider">
                  {item.label}
                </span>
                <span className="text-[12px]">{item.subtitle}</span>
              </div>
            ),
            costPrice: <span>$ {formatDecimal(item.unitPrice, true)}</span>,
            totalCost: (
              <span>$ {formatDecimal(item.qty * item.unitPrice)}</span>
            ),
          };
        })}
      />
    </div>
  );
};

export default ReturnItems;
